import { FC } from 'react';
import classNames from 'classnames';
import { Divider } from 'primereact/divider';
import { isAuthenticated, getAccessToken } from '@/utils/auth';
import { decodeJWT } from '@/utils/decodeJWT';

import { useTranslation } from 'react-i18next';
import { getprivateMenuItems, getPublicMenuItems } from '../menuItems';
import MenuItem from '../MenuItem/MenuItem';
import styles from './MobileMenu.module.scss';

type MobileMenuProps = {
  isMenuOpen: boolean;
  closeMenu: () => void;
};

const MobileMenu: FC<MobileMenuProps> = ({ isMenuOpen, closeMenu }) => {
  const { t: headerTranslates } = useTranslation('header');
  const { t: menuTranslates } = useTranslation('menu');
  const accessToken = getAccessToken();
  const decodedJWTTokenData = accessToken ? decodeJWT(accessToken) : null;
  const accessPages = decodedJWTTokenData?.permisos.split(';') || [];

  const publicMenuItems = getPublicMenuItems(headerTranslates);
  const privateMenuItems = getprivateMenuItems(menuTranslates, accessPages);

  return (
    <nav className={classNames(styles.mobileMenu, isMenuOpen && styles.open)}>
      {isMenuOpen && (
        <ul>
          {isAuthenticated() && (
            <>
              {privateMenuItems.map((item) => {
                const { label, icon, to, items } = item;

                return (
                  <MenuItem
                    key={label}
                    label={label}
                    icon={icon}
                    to={to}
                    isSidebarOpen
                    items={items}
                    closeMobileMenu={closeMenu}
                  />
                );
              })}
              <Divider className={styles.divider} />
            </>
          )}
          {publicMenuItems?.map((item) => {
            const { label, icon, to, items } = item;

            return (
              <MenuItem
                key={label}
                label={label}
                icon={icon}
                to={to}
                isSidebarOpen
                items={items}
                closeMobileMenu={closeMenu}
              />
            );
          })}
        </ul>
      )}
    </nav>
  );
};

export default MobileMenu;
